<template>
  <el-dialog :visible.sync="show" :title="name" width="900px">
    <el-form ref="form" size="small" :model="data" label-width="auto" label-position="right" :rules="rules">
      <el-form-item prop="platformId" label="场站">
        <el-select v-model="data.platformId" placeholder="选择场站" clearable filterable style="width: 100%" disabled>
          <el-option v-for="(item, index) in platformList" :key="index" :value="item.id" :label="item.name"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="createTenantId" label="二房东">
        <el-select v-model="data.createTenantId" placeholder="选择二房东" clearable filterable style="width: 100%" disabled>
          <el-option v-for="(item, index) in tenantList" :key="index" :value="item.id" :label="item.name"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="tenantId" label="货主">
        <el-select v-model="data.tenantId" placeholder="选择货主" clearable filterable style="width: 100%">
          <el-option v-for="(item, index) in unBindTenantList" :key="index" :value="item.id"
            :label="item.name"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <div style="text-align: center">
        <el-button type="primary" style="width: 100%" @click="save" :loading="loading">确定</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      name: '',
      data: {},
      rules: {
        platformId: [{ required: true, trigger: 'change', message: '选择场站' }],
        createTenantId: [{ required: true, trigger: 'change', message: '选择二房东' }],
        tenantId: [{ required: true, trigger: 'change', message: '选择货主' }]
      },
      loading: false,
      platformList: [],
      tenantList: [],
      unBindTenantList: []
    }
  },
  methods: {
    display(e) {
      this.show = true
      this.data = {
        platformId: e.platformId,
        createTenantId: e.createTenantId
      }
      this.platformList = e.platformList
      this.tenantList = e.tenantList
      this.unBindTenantList = []
      const bindTenantList = e.bindTenantList.map(item => { return item.tenantId })
      this.tenantList.forEach(item => {
        if (item.id !== this.data.createTenantId && !bindTenantList.includes(item.id)) {
          this.unBindTenantList.push(item)
        }
      })
      this.name = '二房东绑定货主'
    },

    save() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true
          const params = JSON.parse(JSON.stringify(this.data))
          this.tenantList.forEach(item => {
            if (item.id === this.data.createTenantId) {
              params['createTenantName'] = item.name
            }
            if (item.id === this.data.tenantId) {
              params['tenantName'] = item.name
            }
          })
          this.platformList.forEach(item => {
            if (item.id === this.data.platformId) {
              params['platformName'] = item.name
            }
          })
          this.$axios.post('/account/platform/tenant/second/update', params).then(() => {
            this.$message.success('绑定成功')
            this.show = false
            this.$emit('init')
            this.loading = false
          }).catch(err => {
            console.log('绑定失败', err)
            this.loading = false
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>
